/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlUserInfoResponse
 */
export interface ControlUserInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlUserInfoResponse
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserInfoResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserInfoResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserInfoResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserInfoResponse
     */
    org_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserInfoResponse
     */
    entity_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUserInfoResponse
     */
    msp: boolean;
}

/**
 * Check if a given object implements the ControlUserInfoResponse interface.
 */
export function instanceOfControlUserInfoResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "msp" in value;

    return isInstance;
}

export function ControlUserInfoResponseFromJSON(json: any): ControlUserInfoResponse {
    return ControlUserInfoResponseFromJSONTyped(json, false);
}

export function ControlUserInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'email': json['email'],
        'name': json['name'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'entity_id': json['entity_id'],
        'msp': json['msp'],
    };
}

export function ControlUserInfoResponseToJSON(value?: ControlUserInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'email': value.email,
        'name': value.name,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'entity_id': value.entity_id,
        'msp': value.msp,
    };
}

